import { da } from './da';
import { en } from './en';
import { no } from './no';
import { sv } from './sv';

export const translationsObject = {
    en,
    da,
    no,
    sv,
};
